import React, { useEffect } from "react";
import {
  GeneralTable,
  PopoverButton,
  useModalAlert,
} from "../GeneralComponents";
import moment from "moment";

export function TabletRoleManagement() {
  const [roles, setRoles] = React.useState([]);
  const [listTypesDocumentales, setListTypesDocumentales] = React.useState([]);
  const [formData, setFormData] = React.useState({
    fecha_creacion: moment(),
  });
  const [openModalRole, setopenModalRole] = React.useState(null);
  const { showModalAlert } = useModalAlert();
  const [isEditMode, setIsEditMode] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);

  useEffect(() => {
    loadTipoDocumentales();
  }, []);

  useEffect(() => {
    loadRoles();
  }, [page, pageSize]);

  const handleCloseModal = () => {
    setopenModalRole(false);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const handleOpenModal = (row) => {
    setopenModalRole(true);
    //setDocumentoSeleccionado(row);
  };

  const columns = [
    {
      field: "fecha_creacion",
      headerName: "FECHA CREACIÓN",
      type: "date",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "nombre",
      headerName: "NOMBRE",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "tipo_documental",
      headerName: "TIPOS DOCUMENTALES",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
      align: "left",
      renderCell: (params) => {
        return (
          <PopoverButton
            content={
              <div style={{ whiteSpace: "pre-wrap", padding: "1" }}>
                {Object.values(params.value)
                  .map((tp) => `* ${tp}`)
                  .join("\n")}
              </div>
            }
            buttonText={"Ver más"}
          />
        );
      },
    },
    {
      field: "estado",
      headerName: "ESTADO",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null
          ? params.value === "A"
            ? "Activa"
            : "Inactiva"
          : "No aplica",
    },
  ];

  const newModalField = [
    {
      name: "fecha_creacion",
      label: "Fecha de Creación",
      type: "date",
    },
    { name: "nombre", label: "Nombre del rol", type: "text" },
    {
      name: "tipo_documental",
      label: "Tipo documentales",
      type: "checkbox-group",
      options: listTypesDocumentales,
    },
  ];

  const requiredFields = ["nombre", "tipo_documental"];

  async function handleSaveRole(formData) {
    const tipo_documental = (formData.tipo_documental || []).reduce(
      (acc, id) => {
        const tipoDocumental = listTypesDocumentales.find(
          (item) => item.value === id,
        );
        if (tipoDocumental) {
          acc[id] = tipoDocumental.label;
        }
        return acc;
      },
      {},
    );

    let datos = {
      ...formData,
      tipo_documental,
    };

    try {
      const url = isEditMode
        ? process.env.REACT_APP_PUBLIC_URL + "rol/update"
        : process.env.REACT_APP_PUBLIC_URL + "rol/create";
      const createResponse = await fetch(url, {
        method: isEditMode ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(datos),
      });
      const result = await createResponse.json();
      loadRoles();
      setIsEditMode(false);
      handleCloseModal();
      if (isEditMode) {
        showModalAlert("success", "Se actualizo correctamente el rol");
      } else {
        showModalAlert("success", "Se creo correctamente el rol");
      }
    } catch (error) {
      showModalAlert("danger", "Error al crear el rol");
    }
  }

  const onUpdate = (row) => {};

  const actionsList = [];

  const loadRoles = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `rol/listar?page=${page + 1}&page_size=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setRowCount(data.count);
        setRoles(data.results);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadTipoDocumentales = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-documental/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listatipoDocumental = data.results.map((tipoDocumental) => {
          return {
            value: tipoDocumental.id_gd_tipo_documental,
            label: tipoDocumental.descripcion,
          };
        });
        setListTypesDocumentales(listatipoDocumental);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const consultarRegistro = async () => {
    const response = await fetch(
      process.env.REACT_APP_PUBLIC_URL + "rol/consult",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    );
  };

  const onActivate = async (row) => {
    try {
      let dataSend = {
        id_gd_roles: row.id_gd_roles,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "rol/activar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadRoles();
      showModalAlert("success", "Se activo correctamente el rol");
    } catch {
      showModalAlert("danger", "Error al activar el rol");
    }
  };
  const onInactivate = async (row) => {
    try {
      let dataSend = {
        id_gd_roles: row.id_gd_roles,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "rol/inactivar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadRoles();
      showModalAlert("success", "Se inactivo correctamente el rol");
    } catch {
      showModalAlert("danger", "Error al inactivar el rol");
    }
  };
  return (
    <>
      <GeneralTable
        title=""
        titleAlert="Rol"
        buttonText="Crear Rol"
        columns={columns}
        rows={roles}
        modalFields={newModalField}
        initialFormData={{
          nombre: "",
          fecha_creacion: moment(),
        }}
        onSaveModal={handleSaveRole}
        actionsList={actionsList}
        onActivate={onActivate}
        onInactivate={onInactivate}
        enableUpdate
        onUpdate={onUpdate}
        enableView
        formData={formData}
        setFormData={setFormData}
        enableActivate
        loadList={loadRoles}
        width={"80%"}
        isModalRol={true}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
        consultarRegistro={consultarRegistro}
        rowCount={rowCount}
        pageSize={pageSize}
        page={page}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
        requiredFields={requiredFields}
      />
    </>
  );
}
